import { useQuery } from '@tanstack/react-query';
import type { CampaignEvent, CursorPage } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useCampaignEvents(campaignId: string) {
  return useQuery({
    queryKey: ['campaign-events', campaignId],
    queryFn: () => apiGet<CursorPage<CampaignEvent>>(`/v1/campaigns/${campaignId}/events`),
    enabled: Boolean(campaignId),
    refetchInterval: 5000,
  });
}
